import React from 'react';
import PropTypes from 'prop-types';
import { getPosition, isIterableArray, numberFormatter } from '../../helpers/utils';
import { chartTheme, chartTooltip } from '../../helpers/chartTheme';
import ServiceWidgetItem from './ServiceWidgetItem';
import { Card, CardBody, Col, Row } from 'reactstrap';
import * as echarts from 'echarts';
import ReactEcharts from 'echarts-for-react';
import { useContext } from 'react';
import AppContext from '../../context/Context';

const getOption = (data, isDark) => {
  const t = chartTheme(isDark);
  return {
    color: data?.map(d => d.color),
    tooltip: chartTooltip(t, {
      trigger: 'item',
      padding: [7, 10],
      transitionDuration: 0,
      formatter: function(params) {
        return `<strong>${params.data.name}:</strong> ${params.percent}%`;
      }
    }),
    position(pos, params, dom, rect, size) {
      return getPosition(pos, params, dom, rect, size);
    },
    legend: { show: false },
    series: [
      {
        type: 'pie',
        radius: ['100%', '87%'],
        avoidLabelOverlap: false,
        emphasis: {
          scale: false,
          disabled: true
        },
        label: {
          show: false
        },
        labelLine: { show: false },
        itemStyle: {
          borderWidth: 2,
          borderColor: t.bg,
          label: {
            show: false
          },
          labelLine: {
            show: false
          }
        },
        data: data
      }
    ]
  };
};

const ServiceWidget = ({ data, title, status, loading }) => {
  // const [filteredData, setFilteredData] = useState(data);
  const { isDark } = useContext(AppContext);
  // useEffect(() => {
  //   // console.log('status', status);
  //   setFilteredData(data?.filter(d => d.filter === status?.value));
  //   // console.log('filtered: ', filteredData);
  // }, [data, status]);
  // const filteredData = data.filter(d => d.filter === status.value);
  const totalShare = data?.map(d => d.value).reduce((total, currentValue) => total + currentValue, 0);
  return (
    <Card className="h-md-100">
      <CardBody>
        <Row className="h-100 justify-content-between">
          <Col xs={5} sm={6} className="col-xxl pr-2">
            <h6 className="mt-1">{title}</h6>
            <div className={`${loading ? 'loading-skeleton' : ''} fs--2 mt-3`}>
              {!loading ? (
                <>
                  {!status?.value
                    ? data?.map(({ id, ...rest }) => <ServiceWidgetItem {...rest} totalShare={totalShare} key={id} />)
                    : isIterableArray(data) &&
                      data
                        ?.filter(d => d.filter === status.value)
                        ?.map(({ id, ...rest }) => <ServiceWidgetItem {...rest} totalShare={totalShare} key={id} />)}
                </>
              ) : (
                <></>
              )}
            </div>
          </Col>
          <Col xs="auto">
            <div className="position-relative">
              <ReactEcharts
                echarts={echarts}
                option={getOption(data, isDark)}
                style={{ width: '6.625rem', height: '6.625rem' }}
              />
              <div
                className={`${loading ? 'loading-skeleton ' : 'text-dark'} absolute-centered font-weight-medium  fs-2`}
                data-testid={'bugs-count'}
              >
                {numberFormatter(totalShare, 0)}
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

ServiceWidget.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  status: PropTypes.object,
  loading: PropTypes.bool
};

export default ServiceWidget;
